import { merge } from 'lodash';

import { type Metadata } from 'hb-react/shared/components/ShoppingCard/hooks/v2';
import { type User } from 'hb-react/types';

export const getInitialValues = (
  {
    currentUser,
    metadata,
    isShippable = false,
    values = {},
  }: {
    currentUser: User | null;
    isShippable?: boolean;
    metadata?: Metadata;
    values?: any;
  },
  { selectedAddress } = { selectedAddress: 'personal' },
) => {
  const address = currentUser?.postal_address?.[selectedAddress];

  const shippingAddressAttributes = {
    same_as_billing: true,
    full_name: currentUser?.name,
    address_1: address?.address_1 || '',
    address_2: address?.address_2 || '',
    address_3: address?.address_3 || '',
    country: address?.country || '',
    city: address?.city || '',
    postal_code: address?.postal_code || '',
    state: address?.state || '',
    captcha_response: '',
  };

  return merge(
    {
      receipt: {
        firstname: metadata?.user?.firstname ?? currentUser?.firstname ?? '',
        lastname: metadata?.user?.lastname ?? currentUser?.lastname ?? '',
        email: metadata?.user?.email ?? currentUser?.email ?? '',
        address_type: selectedAddress,
        billing_address_attributes: {
          address_1: address?.address_1 || '',
          address_2: address?.address_2 || '',
          address_3: address?.address_3 || '',
          country: address?.country || '',
          city: address?.city || '',
          postal_code: address?.postal_code || '',
          state: address?.state || '',
        },
        shipping_address_attributes: isShippable && shippingAddressAttributes,
      },
    },
    values,
  );
};
